import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatLocation } from "../../../utils/formatLocation";

// Navy header for a team page seen by a logged-in player, laid out like the
// player's own profile header: back link, team logo, name, and the basics.

export const TeamLogo = ({ name, logo }) => {
  const [failed, setFailed] = useState(false);

  return (
    // Fixed inset (not %, which is measured against the header's width) keeps a
    // square logo's corners inside the circle. Sized ~1.6x the name's font at each
    // breakpoint (36/48/60px name -> 64/80/96px logo).
    <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 flex-shrink-0 rounded-full overflow-hidden bg-white flex items-center justify-center p-2.5 sm:p-3 lg:p-4">
      {logo && !failed ? (
        <img src={logo} alt={`${name} logo`} onError={() => setFailed(true)} className="w-full h-full object-contain" />
      ) : (
        <svg className="w-3/5 h-3/5 text-jp-band" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z" />
        </svg>
      )}
    </div>
  );
};

export const PlayerTeamHeader = ({ teamData }) => {
  const navigate = useNavigate();
  const name = teamData?.name || "Team";
  const subtitle = [teamData?.division, teamData?.conference, formatLocation(teamData?.location)].filter(Boolean).join(" · ");

  return (
    <section className="bg-jp-band px-4 sm:px-6 lg:px-8 pt-28 sm:pt-32 pb-10">
      <div className="max-w-7xl mx-auto">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-6 inline-flex items-center gap-2 text-slate-300 hover:text-white text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 rounded"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>

        <div className="flex items-center gap-5 min-w-0">
          <TeamLogo name={name} logo={teamData?.logo} />
          <div className="min-w-0">
            <p className="text-yellow-300 text-sm font-bold uppercase tracking-widest mb-2">Team Profile</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-anton leading-[1.1] tracking-tight text-white uppercase">
              {name}
            </h1>
            {subtitle && <p className="text-slate-300 text-sm sm:text-base mt-2">{subtitle}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};
